﻿$.fn.dxCtrlGridSupport = function custom_dxCtrlGridSupport(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlgridsupport dx-ctrl");
        this.createInstance(new cdxCtrlGridSupport(this, option));
    }
    return this;
}

window.cdxCtrlGridSupport = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }
    if (typeof option.context_grid == 'undefined') option.context_grid = "gridsupport"
    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid] == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid] = {}
    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].tous_utilisateur == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid].tous_utilisateur = false

    var _disableUpdateFunction = false
    var timeOutUpdate = null
    option.bddCtrl.mAddFunctionOnModifiedItemData(["support_ticket"], container,
        function (action, itemData) {
            if (_disableUpdateFunction) {
                _disableUpdateFunction = false
                return
            }
            window.clearTimeout(timeOutUpdate)
            timeOutUpdate = window.setTimeout(function () {
                if (typeof itemData != 'undefined') {
                    dxGrid.mUpdateData(action, option.bddCtrl.table.mGetItemFromNom("support_ticket").id_table, itemData.id_support_ticket)
                } else {
                    dxGrid.mUpdateData()
                }
            }, 100)
        })

    var dxGrid = null
    var messageNoDataText = "Aucun ticket ouvert"
    function mConstruit() {
        container.empty();
        container.css("height", "100%")
        container.css("position", "relative")

        var lstField = mGetLstField()
        var opt = {
            bddCtrl: option.bddCtrl,
            typeData: "support",
            noDataText: function (contentElement) {
                contentElement.empty()
                $("<div>" + messageNoDataText + "</div>").appendTo(contentElement)
                if (!option.isGestionnaire) {
                    var $DivClick = $("<div style='padding:20px'><i class='fas fa-user-doctor' style='padding-right:5px;'></i></div>").appendTo(contentElement)
                    var $A = $("<a href='javascript:void(0)'>Créer un ticket de support</a>").appendTo($DivClick)
                    $A.on("click", function (e) {
                        Me.mShowNewSupport()
                    })
                }
            },
            context_grid: option.context_grid,
            lstLstConditionBase: mGetLstLstConditionBase(),
            itemsToolbar: mGetLstButtonToolBar(),
            onDisplayButtonLigne: mGetLstButtonLigne,
            onClickDataGrid: function (container, dataGrid, dataTemplate) {
                container.closest(".divtemplate").css("box-shadow","")
                Me.mShowSupport(dataGrid.id)
            },
            lstTypeGrille: ["Détails", "Lignes"],
            fields: lstField,
            allowFilter: false,
            allowCarto: false,
            allowLucene: true,
            allowGroup: false,
            allowCheck: false,
            allowToolbar: option.allowToolbar,
            allowDeleteInToolbar: false,
            showColumnHeaders: false,
            lstIdTableIdExclu: option.lstIdTableIdExclu,
            lstIdTableIdInclu: option.lstIdTableIdInclu
        }

        dxGrid = $("<div/>").appendTo(container).dxCtrlVirtualGrid(opt).dxCtrlVirtualGrid("instance")
    }

    this.mShowSupport = function (idSupportTicket) {
        option.onDemandeAfficheSupport(idSupportTicket)
        //var $DivShading = $("<div style='width:100%;height:100%;position:absolute;z-index:2;display:none;top:0;right:0;' class='dx-overlay-shader'/>").appendTo(container)
        //var $DivInner = $("<div style='width:100%;height:100%;position:relative;'/>").appendTo($DivShading)
        //var $DivInnerInner = $("<div style='position:absolute;top:0;right:0;height:100%;" + ((option.isGestionnaire) ? "" : "max-width:600px;") + "width:100%;'/>").appendTo($DivInner)
        //var dxPopupTicket = $("<div class='dx-theme-material-typography' style='height:100%;padding:5px;'/>").appendTo($DivInnerInner).dxCtrlContentDemandeSupport({
        //    bddCtrl:option.bddCtrl,
        //    idSupportTicket: idSupportTicket,
        //    idCompteClient: option.idCompteClient,
        //    idUtilisateurClient: option.idUtilisateurClient,
        //    idUtilisateurGest: option.idUtilisateurGest,
        //    onClose: function () {
        //        $DivShading.fadeOut(300, function () { dxPopupTicket.element().remove() })
        //    }
        //}).dxCtrlContentDemandeSupport("instance")
        //$DivShading.fadeIn(300)
    }

    this.mShowNewSupport = function () {
        option.onDemandeCreateNewSupport()
        //var $DivShading = $("<div style='width:100%;height:100%;position:absolute;z-index:2;display:none;top:0;right:0;'/>").appendTo(container)
        //var $DivInner = $("<div style='width:100%;height:100%;position:relative;'  class='dx-overlay-shader dx-popup-wrapper'/>").appendTo($DivShading)
        //var $DivInnerInner = $("<div style='position:absolute;top:0;right:0;height:100%;" + ((option.isGestionnaire) ? "" : "max-width:600px;") + "width:100%;' class='dx-overlay-content'/>").appendTo($DivInner)
        //var dxPopupTicket = $("<div class='dx-theme-material-typography' style='height:100%;'/>").appendTo($DivInnerInner).dxCtrlContentDemandeNewSupport({
        //    bddCtrl: option.bddCtrl,
        //    idCompteClient: option.idCompteClient,
        //    idUtilisateurClient: option.idUtilisateurClient,
        //    onClose: function () {
        //        $DivShading.fadeOut(300, function () { dxPopupTicket.element().remove() })
        //    }
        //}).dxCtrlContentDemandeNewSupport("instance")
        //$DivShading.fadeIn(300)
    }

    function mGetLstField() {
        var lst = []
        lst = lst.concat([{
            name: "dmo",
            dataField: "dmo",
            caption: "Date création",
            icon: "fas fa-clock",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            groupIndex: 0,
            sortOrder: "desc",
            filterLinkGrp: "dmo_tri",
            dataType: "date",
            filterProperty: {
                filterOperations: ["=", "<>", "<", ">", "<=", ">=", "between", "isblank", "isnotblank", "superieurouegaletoday", "inferieurouegaletoday"]
            },
            calculateGroupValue: function (rowData) {
                return rowData.dmo.toGrpDate().id
            },
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-clock-rotate-left dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Modification: " + options.data.key.getGroupDateLibelle() + " (" + tot + ")")
            },
        }])
        lst.push({
            name: "dmo_tri",
            dataField: "dmo_tri",
            allowGrid: true,
            visible: false
        }) //dcr_tri
        lst = lst.concat([{
            name: "id_compte_client",
            dataField: "id_compte_client",
            caption: "id_compte_client",
            icon: "fas fa-book-open-reader",
            allowFilter: true,
            allowGrid: false,
            allowGrouping: false,
            allowSorting: false,
            dataType: "number"
        }, {
            name: "id_utilisateur_client",
            dataField: "id_utilisateur_client",
            caption: "id_utilisateur_client",
            icon: "fas fa-user",
            allowFilter: true,
            allowGrid: false,
            allowGrouping: false,
            allowSorting: false,
            dataType: "number"
        }, {
            name: "id_utilisateur_gest",
            dataField: "id_utilisateur_gest",
            caption: "id_utilisateur_gest",
            icon: "fas fa-user-doctor",
            allowFilter: true,
            allowGrid: false,
            allowGrouping: false,
            allowSorting: false,
            dataType: "number"
        }, {
            name: "attente_utilisateur",
            dataField: "attente_utilisateur",
            caption: "attente_utilisateur",
            icon: "fas fa-hourglass-start",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "string"
        }, {
            name: "ouvert",
            dataField: "ouvert",
            caption: "Ouvert",
            icon: "fas fa-door-open",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: false,
            allowSorting: true,
            dataType: "bit"
        }, {
            name: "resolue",
            dataField: "resolue",
            caption: "Résolue",
            icon: "fas fa-check",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: false,
            allowSorting: true,
            dataType: "bit"
        }])

        return lst
    }

    var lstStatut = ["Ouvert"]
    var resolue = false
    var aVousChecked = option.isGestionnaire
    function mGetLstButtonToolBar() {
        var items = []

        if (typeof option.idCompteClient != 'undefined' && option.idCompteClient != null) {
            items.push({
                location: 'before',
                template: function (itemData, itemIndex, itemElement) {
                    $("<div/>").appendTo(itemElement).dxCtrlButton({
                        icon: "fas fa-user-doctor",
                        width: 130,
                        html: "<div style='text-align:left;'>Nouveau<br/>ticket</div>",
                        txtTooltip: "Créer un nouveau ticket de support",
                        onClick: function (e) {
                            Me.mShowNewSupport()
                        }
                    }).dxCtrlButton("instance")
                }
            })
        } else {
            //items.push({
            //    location: 'before',
            //    template: function (itemData, itemIndex, itemElement) {
            //        $("<div/>").appendTo(itemElement).dxCtrlButton({
            //            icon: "fas fa-user-astronaut",
            //            width: 130,
            //            text: "liste Q/R IA",
            //            txtTooltip: "Liste des question/reponse IA",
            //            onClick: function (e) {
            //                var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
            //                    position: {
            //                        my: "right top",
            //                        at: "right top",
            //                        of: "body"
            //                    },
            //                    hideOnOutsideClick: false,
            //                    width: 800,
            //                    height: "100%",
            //                    showTitle: true,
            //                    title: "Question/reponse IA",
            //                    showMaximize: true,
            //                    resizeEnabled: true,
            //                    shading: false,
            //                    contentTemplate: function (contentElement) {
            //                        $("<div/>").appendTo(contentElement).dxCtrlGridCognossIa({ bddCtrl: option.bddCtrl })
            //                    }
            //                }).dxCtrlPopupBase("instance")
            //                popup.show()
            //            }
            //        }).dxCtrlButton("instance")
            //    }
            //})
            items.push({
                location: 'before',
                template: function (itemData, itemIndex, itemElement) {
                    $("<div/>").appendTo(itemElement).dxCtrlButton({
                        icon: "fas fa-certificate",
                        txtTooltip: "Initier un ticket avec un utilisateur",
                        onClick: function (e) {
                            Me.mShowNewSupport()
                            //var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
                            //    position: {
                            //        my: "right top",
                            //        at: "right top",
                            //        of: "body"
                            //    },
                            //    hideOnOutsideClick: false,
                            //    width: 800,
                            //    height: "100%",
                            //    showTitle: true,
                            //    title: "Question/reponse IA",
                            //    showMaximize: true,
                            //    resizeEnabled: true,
                            //    shading: false,
                            //    contentTemplate: function (contentElement) {
                            //        $("<div/>").appendTo(contentElement).dxCtrlGridCognossIa({ bddCtrl: option.bddCtrl })
                            //    }
                            //}).dxCtrlPopupBase("instance")
                            //popup.show()
                        }
                    }).dxCtrlButton("instance")
                }
            })
        }

        items.push({
            location: 'before',
            template: function (itemData, itemIndex, itemElement) {
                itemElement.css("height", "100%")
                var ds = ["En cours", "Résolue", "Fermé"]
                $("<div style='height:100%;'/>").appendTo(itemElement).dxTabs({
                    dataSource: ds,
                    selectedItem: ds[0],
                    itemTemplate: function (itemData, itemIndex, itemElement) {
                        switch (itemData) {
                            case "En cours":
                                itemElement.attr("title", "Tickets ouverts")
                                break;
                            case "Résolue":
                                itemElement.attr("title", "Tickets ouverts/résolus")
                                break;
                            case "Fermé":
                                itemElement.attr("title", "Tickets fermés")
                                break;
                        }
                        itemElement.text(itemData)
                    },
                    onItemClick: function (e) {
                        switch (e.itemData) {
                            case "En cours":
                                messageNoDataText = "Aucun ticket ouvert"
                                lstStatut = ["Ouvert"]
                                resolue = false
                                break;
                            case "Résolue":
                                messageNoDataText = "Aucun ticket ouverts/résolu"
                                lstStatut = ["Résolue"]
                                resolue = true
                                break;
                            case "Fermé":
                                messageNoDataText = "Aucun ticket fermé"
                                lstStatut = ["Fermé"]
                                break;
                        }
                        dxGrid.option("lstLstConditionBase", mGetLstLstConditionBase())
                        dxGrid.mReloadData()
                    }
                }).dxCtrlButton("instance")
            }
        })

        if (parametre.baseAppli.para.is_multi_utilisateur == "1") {
            items.push({
                location: 'before',
                template: function (itemData, itemIndex, itemElement) {
                    itemElement.css("height", "100%")
                    $("<div style='height:100%;'/>").appendTo(itemElement).dxCheckBox({
                        text: "Tous utilisateurs",
                        value: false,
                        focusStateEnabled: false,
                        onValueChanged: function (e) {
                            option.bddCtrl.utiCourantParaJson[option.context_grid].tous_utilisateur = e.value
                            option.bddCtrl.mSaveParaJsonUtilisateur();
                            dxGrid.option("lstLstConditionBase", mGetLstLstConditionBase())
                            dxGrid.mReloadData()
                        },
                        onContentReady: function (e) {
                            e.element.find(".dx-checkbox-text").html("Tous les<br/>utilisateurs").css("font-family", "barlow condensed").css("line-height", "0.9")
                        }
                    }).dxCtrlButton("instance")
                }
            })
        }


        items.push({
            location: 'before',
            template: function (itemData, itemIndex, itemElement) {
                itemElement.css("line-height", "1")
                $("<a style='font-family:barlow condensed;' href='" + parametre.baseAppli.url_planiti_rdv + "' target='_blank' title='Choisir un créneaux pour être rappeler par le support'>Rendez-vous téléphonique<br/>avec le support</a>").appendTo(itemElement)
            }
        })


        //items.push({
        //    location: 'after',
        //    template: function (itemData, itemIndex, itemElement) {
        //        var dxChkResolu = $("<div/>").appendTo(itemElement).dxCheckBox({
        //            text: "Résolue",
        //            value: resolue,
        //            width: 80,
        //            onValueChanged: function (e) {
        //                resolue = e.value
        //                dxGrid.option("lstLstConditionBase", mGetLstLstConditionBase())
        //                dxGrid.mReloadData()
        //            }
        //        }).dxCheckBox("instance")
        //    }
        //})
        //items.push({
        //    location: 'after',
        //    template: function (itemData, itemIndex, itemElement) {
        //        var dxTagBoxStatut = $("<div style='min-width:200px'/>").appendTo(itemElement).dxTagBox({
        //            labelMode: "floating",
        //            label: "Statut",
        //            width: "100%",
        //            placeholder: "Tous les statuts...",
        //            dataSource: ["Ouvert", "Fermé"],
        //            value: lstStatut,
        //            onValueChanged: function (e) {
        //                lstStatut = e.value
        //                dxGrid.option("lstLstConditionBase", mGetLstLstConditionBase())
        //                dxGrid.mReloadData()
        //            }
        //        }).dxTagBox("instance")
        //    }
        //})
        //items.push({
        //    location: 'after',
        //    template: function (itemData, itemIndex, itemElement) {
        //        itemElement.css("text-align", "center")
        //        dxCheckBoxAVous = $("<div style='display:inline-block'/>").appendTo(itemElement).dxCheckBox({
        //            text: "A vous",
        //            value: aVousChecked,
        //            onValueChanged: function (e) {
        //                aVousChecked = e.value
        //                dxGrid.option("lstLstConditionBase", mGetLstLstConditionBase())
        //                dxGrid.mReloadData()
        //            }
        //        }).dxCheckBox("instance")
        //    }
        //})

        return items
    }

    function mGetLstLstConditionBase() {
        var lstLstConditionBase = [[]]
        switch (lstStatut[0]) {
            case "Ouvert":
                lstLstConditionBase[0].push({ nom_champ: "ouvert", ope: "=", valeur: [{ value: 1 }] })
                lstLstConditionBase[0].push({ nom_champ: "resolue", ope: "=", valeur: [{ value: 0 }] })
                break;
            case "Résolue":
                lstLstConditionBase[0].push({ nom_champ: "ouvert", ope: "=", valeur: [{ value: 1 }] })
                lstLstConditionBase[0].push({ nom_champ: "resolue", ope: "=", valeur: [{ value: 1 }] })
                break;
            case "Fermé":
                lstLstConditionBase[0].push({ nom_champ: "ouvert", ope: "=", valeur: [{ value: 0 }] })
                break;
        }
        //if (lstStatut.length > 0) {
        //    var lstId = []
        //    lstStatut.forEach(function (idStatut) {
        //        if (idStatut == "Ouvert") { lstLstConditionBase.push([{ nom_champ: "ouvert", ope: "=", valeur: [{ value: 1 }] }]) }
        //        //if (idStatut == "Résolue") { lstLstConditionBase.push([{ nom_champ: "resolue", ope: "=", valeur: [{ value: 1 }] }]) }
        //        if (idStatut == "Fermé") { lstLstConditionBase.push([{ nom_champ: "ouvert", ope: "=", valeur: [{ value: 0 }] }]) }
        //        //lstId.push({ value: ((idStatut == "Ouvert") ? "0" : ((idStatut == "Résolue") ? "1" : "2")) })
        //    })
        //    //lstConditionBase.push({ nom_champ: "id_statut_ticket", ope: "parmi", valeur: lstId })
        //} else { lstLstConditionBase.push([]) }
        ////if (resolue) {
        //lstLstConditionBase.forEach(function (lstConditionBase) {
        //    lstConditionBase.push({ nom_champ: "resolue", ope: "=", valeur: [{ value: ((resolue) ? 1 : 0) }] })
        //})
        ////}
        ////aVousChecked
        ////if (aVousChecked) {
        ////    if (lstLstConditionBase.length == 0) lstLstConditionBase.push([])
        ////    lstLstConditionBase.forEach(function (lstConditionBase) {
        ////        if (option.isGestionnaire) {
        ////            //on est sur le gestionnaire
        ////            lstConditionBase.push({ nom_champ: "attente_utilisateur", ope: "=", valeur: [{ value: "2" }] })
        ////        } else {
        ////            lstConditionBase.push({ nom_champ: "attente_utilisateur", ope: "=", valeur: [{ value: "1" }] })
        ////        }
        ////    })
        ////}

        if (typeof option.idCompteClient != 'undefined') {
            //if (lstLstConditionBase.length == 0) lstLstConditionBase.push([])
            lstLstConditionBase.forEach(function (lstConditionBase) {
                lstConditionBase.push({ nom_champ: "id_compte_client", ope: "=", valeur: [{ value: option.idCompteClient }] })
            })
        }

        if (typeof option.idUtilisateurClient != 'undefined' && !option.bddCtrl.utiCourantParaJson[option.context_grid].tous_utilisateur) {
            //if (lstLstConditionBase.length == 0) lstLstConditionBase.push([])
            lstLstConditionBase.forEach(function (lstConditionBase) {
                lstConditionBase.push({ nom_champ: "id_utilisateur_client", ope: "=", valeur: [{ value: option.idUtilisateurClient }] })
            })
        }

        return lstLstConditionBase
    }

    function mGetLstButtonLigne(toolbar, dataGrid, dataTemplate) {
        var items = []
        if (dataTemplate.id_utilisateur_client == option.bddCtrl.utiCourant.id_utilisateur) {
            if (dataGrid.resolue == "0") {
                items.push({
                    location: 'before',
                    widget: 'dxButton',
                    //showText: "inMenu",
                    options: {
                        focusStateEnabled: false,
                        text: "Résoudre",
                        hint: "Résoudre le ticket",
                        onClick(e) {
                            e.event.stopPropagation();
                            dxGrid.mRemoveRow(dataGrid)
                            var data = option.bddCtrl.getObjet("support_ticket", dataGrid.id).data
                            data.resolue = 1
                            option.bddCtrl.getObjet(data).mSaveChamp("resolue")
                        },
                        onContentReady: function (e) {
                            e.component.element().find(".dx-icon").addClass("dx-theme-accent-as-text-color")
                            e.component.element().find(".dx-button-content").css("background-color", theme.backgroundcolorTooltip.replace("rgb(", "rgba(").replace(")", ", 0.6)"))
                        }
                    },
                })
            }
            if (dataGrid.ouvert == "1") {
                items.push({
                    location: 'before',
                    widget: 'dxButton',
                    //showText: "inMenu",
                    options: {
                        focusStateEnabled: false,
                        text: "Fermer",
                        hint: "Fermer le ticket",
                        onClick(e) {
                            e.event.stopPropagation();
                            dxGrid.mRemoveRow(dataGrid)
                            var data = option.bddCtrl.getObjet("support_ticket", dataGrid.id).data
                            data.ouvert = 0
                            option.bddCtrl.getObjet(data).mSaveChamp("ouvert")
                        },
                        onContentReady: function (e) {
                            e.component.element().find(".dx-icon").addClass("dx-theme-accent-as-text-color")
                            e.component.element().find(".dx-button-content").css("background-color", theme.backgroundcolorTooltip.replace("rgb(", "rgba(").replace(")", ", 0.6)"))
                        }
                    },
                })
            }
        }

        if (option.isGestionnaire) {
            items.push({
                location: 'before',
                widget: 'dxButton',
                showText: "inMenu",
                options: {
                    icon: "fas fa-trash-alt",
                    elementAttr: { class: "dx-button-grille-ligne" },
                    focusStateEnabled: false,
                    text: "Supprimer",
                    hint: "Supprimer",
                    onClick(e) {
                        e.event.stopPropagation();
                        dxGrid.mRemoveRow(dataGrid)
                        var obj = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(dataGrid.id_table).nom, dataGrid.id)
                        _disableUpdateFunction = true
                        obj.mDelData(function () { })
                    }
                },
            })
        }
        toolbar.option("items", items)
    }

    this.mChangeLstIdTableIdExclu = function (lstId) {
        dxGrid.mChangeLstIdTableIdExclu(lstId)
    }
    this.mChangeLstIdTableIdInclu = function (lstId) {
        dxGrid.mChangeLstIdTableIdInclu(lstId)
    }

    mConstruit();

}